import { render, staticRenderFns } from "./UiAlert.vue?vue&type=template&id=e71aae62&scoped=true&"
import script from "./UiAlert.vue?vue&type=script&lang=ts&"
export * from "./UiAlert.vue?vue&type=script&lang=ts&"
import style0 from "./UiAlert.vue?vue&type=style&index=0&id=e71aae62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71aae62",
  null
  
)

export default component.exports